import React from "react";
import Footer from "../core/Footer";
import Header from "../core/Header";
import Features from "./sections/Features";
import GetStartedCard from "./sections/GetStartedCard";
import Plan from "./sections/Plan";
import Amazon from "./sections/Amazon";
import Companies from "./sections/Companies";
import Banner from "./sections/Banner";
import Testimonials from "./sections/Testimonials";
import InteractiveDemo from "./sections/InteractiveDemo";
import HowItWorks from "./sections/HowItWorks";
import useScrollToTop from "../../hooks/useScrollToTop";
import SEOHead from "../seo/SEOHead";

const MainIndex = () => {
  useScrollToTop();

  return (
    <div>
      <SEOHead 
        title="Automate Amazon Customization Sync to ShipStation & Veeqo"
        description="CustomSync automatically maps Amazon customization data to your shipping platforms. Eliminate manual data entry and reduce errors with seamless integration between Amazon, ShipStation, and Veeqo."
        keywords="Amazon customization sync, ShipStation integration, Veeqo integration, e-commerce automation, order management, customization mapping, Amazon seller tools"
        type="website"
        url="https://customsync.app"
      />
      <Header />
      <div className="overflow-x-hidden">
        <Banner />
        <Testimonials />
        <InteractiveDemo />
        <HowItWorks />
        <Companies />
        <Features />
        <Amazon />
        <Plan />
        <GetStartedCard />
        <Footer />
      </div>
    </div>
  );
};

export default MainIndex;
